import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
  padding: 14px 32px;
`;

export const ControlsBar = styled.div`
  display: flex;
  align-items: center;

  > button {
    background-color: ${colors.grey1};

    > span {
      max-width: 135px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`;

export const RightAlign = styled.div`
  margin-left: auto;
`;

export const TooltipHandle = styled.div`
  display: flex;
`;

export const WarningMessage = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 16px 5px 16px;
  border: 1px solid ${colors.amber};
  border-radius: 8px;
  background-color: ${colors.white};
  align-items: center;
  flex-direction: column;
  margin-top: 14px;

  > span {
    color: ${colors.black};
    font-size: 13px;
    line-height: 19px;
    text-align: center;
    letter-spacing: 0.3px;
    padding-bottom: 10px;
    white-space: pre-line;
  }
`;
